import { Type } from '@angular/core';

export class SidePanelModel<T> {
  constructor(
    public component: Type<T>,
    public heading: string,
    public options: { width?: 'sm' | 'md' | 'lg' | 'xl' } = {},
  ) {}
}
